import { render, staticRenderFns } from "./ConfiguracionUtilitario.vue?vue&type=template&id=63d826f4&scoped=true&"
import script from "./ConfiguracionUtilitario.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionUtilitario.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionUtilitario.vue?vue&type=style&index=0&id=63d826f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d826f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VIcon,VRadio,VRadioGroup})
